import { useCallback, useContext } from 'react';
import { imageViewerContext } from '../ImageViewerContext';
import { Button } from '@mui/material';
import { makeStyles } from '@mui/styles';
import useSmallDesktopScreen from 'hooks/useSmallDesktopScreen';
import {ArrowRightFilled} from 'components/icons';

const useStyles = makeStyles(() => ({
  button: {
    right: '5%',
    position: 'absolute',
    top: '50%',
    transform: 'translate(0, -50%)',
  },
  arrow: {
    width: 80,
    height: 80,
  }
}), { name: 'NextButton' });

const NextButton = (): JSX.Element | null => {
  const classes = useStyles();

  const { currentViewedImage, imageDocuments, handleCurrentViewedImage } = useContext(imageViewerContext);

  const isSmallScreen = useSmallDesktopScreen();

  const currentViewedImageIndex = imageDocuments.findIndex(
    (image) => image.id === currentViewedImage?.id,
  );
  const nextImage = imageDocuments[currentViewedImageIndex + 1];

  const handleNextImageClick = useCallback(
    () => handleCurrentViewedImage(nextImage),
  [nextImage, handleCurrentViewedImage]);

  if (
    isSmallScreen ||
    currentViewedImageIndex === -1 ||
    currentViewedImageIndex === imageDocuments.length - 1
  ) {
    return null;
  }

  return (
    <Button
      className={classes.button}
      onClick={handleNextImageClick}
    >
      <ArrowRightFilled className={classes.arrow} />
    </Button>
  );
};

export default NextButton;